export const CONTENT_MAX_WIDTH = 632;

export const SETTINGS_HORIZONTAL_PADDING = "24px";
export const SETTINGS_SCROLL_BOTTOM_PADDING = "48px";

export const COLORS = {
  textPrimary: "#061522",
  textSecondary: "#405261",
  textPlaceholder: "#C5CED6",
  border: "#D5DCE1",
  borderLight: "#E5E9EC",
  primary: "#148DFD",
  error: "#FF4D4F",
  white: "#FFFFFF",
  backgroundLight: "#F9FAFA",
  shadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
};

export const FONT = {
  family: "Inter, sans-serif",
};

export const settingsTabBarSx = {
  display: "flex",
  gap: "24px",
  width: "100%",
  alignItems: "flex-end",
  borderBottom: `1px solid ${COLORS.borderLight}`,
  flexShrink: 0,
};

export const settingsTabBarBleedSx = {
  px: SETTINGS_HORIZONTAL_PADDING,
  width: "100%",
  boxSizing: "border-box",
};

export const settingsTabItemSx = {
  display: "inline-flex",
  alignItems: "center",
  margin: 0,
  minHeight: 0,
  height: "auto",
  color: COLORS.textSecondary,
  fontFamily: FONT.family,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "18px",
  textDecoration: "none",
  cursor: "pointer",
  pt: 0,
  px: 0,
  pb: "16px",
  background: "none",
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
  borderBottom: "2px solid transparent",
  marginBottom: "-1px",
  appearance: "none",
  outline: "none",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  font: "inherit",
};

export const settingsTabItemActiveSx = {
  color: COLORS.textPrimary,
  fontWeight: 500,
  borderBottomColor: COLORS.primary,
};

export const pageTitleSx = {
  mt: "64px",
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "24px",
  fontWeight: 500,
  lineHeight: "34px",
};

export const pageDescSx = {
  mt: "8px",
  color: COLORS.textSecondary,
  fontFamily: FONT.family,
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "18px",
};

export const contentSx = {
  width: "100%",
  maxWidth: CONTENT_MAX_WIDTH,
  mx: "auto",
  pb: SETTINGS_SCROLL_BOTTOM_PADDING,
  boxSizing: "border-box",
};

export const contentWideSx = {
  width: "100%",
  maxWidth: "100%",
  pb: SETTINGS_SCROLL_BOTTOM_PADDING,
  boxSizing: "border-box",
};

export const settingsScrollContainerSx = {
  width: "100%",
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
};

export const settingsScrollInnerSx = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  boxSizing: "border-box",
  px: SETTINGS_HORIZONTAL_PADDING,
};

export const settingsScrollFullBleedSx = {
  width: `calc(100% + 2 * ${SETTINGS_HORIZONTAL_PADDING})`,
  maxWidth: `calc(100% + 2 * ${SETTINGS_HORIZONTAL_PADDING})`,
  marginLeft: `calc(-1 * ${SETTINGS_HORIZONTAL_PADDING})`,
  marginRight: `calc(-1 * ${SETTINGS_HORIZONTAL_PADDING})`,
  boxSizing: "border-box",
};

export const secondaryButtonSx = {
  height: "40px",
  px: "16px",
  borderRadius: "8px",
  border: `1px solid ${COLORS.border}`,
  background: COLORS.white,
  boxShadow: COLORS.shadow,
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "18px",
  textTransform: "none",
  "&:disabled": {
    opacity: 0.6,
  },
};

export const primaryButtonSx = {
  width: "216px",
  height: "40px",
  borderRadius: "8px",
  border: "none",
  bgcolor: COLORS.primary,
  backgroundColor: COLORS.primary,
  boxShadow: COLORS.shadow,
  color: COLORS.white,
  fontFamily: FONT.family,
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "18px",
  textTransform: "none",
  "&:hover": {
    bgcolor: "#127EDE",
    backgroundColor: "#127EDE",
    boxShadow: COLORS.shadow,
  },
  "&:active": {
    bgcolor: "#0F6FC8",
    backgroundColor: "#0F6FC8",
  },
  "&.Mui-disabled": {
    opacity: 0.7,
    color: COLORS.white,
    bgcolor: COLORS.primary,
    backgroundColor: COLORS.primary,
  },
};

export const errorTextSx = {
  color: COLORS.error,
  fontFamily: FONT.family,
  fontSize: "12px",
  mt: "4px",
};

export const cardTitleSx = {
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "22px",
  m: 0,
};

export const cardDescSx = {
  color: COLORS.textSecondary,
  fontFamily: FONT.family,
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "18px",
  m: 0,
};

export const inputLabelSx = {
  mb: "8px",
  color: COLORS.textSecondary,
  fontFamily: FONT.family,
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "normal",
};

export const textFieldSx = {
  width: "100%",
  maxWidth: CONTENT_MAX_WIDTH,
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: "8px",
    fontFamily: FONT.family,
    fontSize: "14px",
    fontWeight: 400,
    color: COLORS.textPrimary,
    boxShadow: COLORS.shadow,
    background: COLORS.white,
    "& fieldset": {
      borderColor: COLORS.border,
    },
    "&:hover fieldset": {
      borderColor: COLORS.border,
    },
    "&.Mui-focused fieldset": {
      borderColor: COLORS.primary,
    },
  },
  "& .MuiOutlinedInput-input": {
    py: 0,
    px: "12px",
    "&::placeholder": {
      color: COLORS.textPlaceholder,
      opacity: 1,
    },
  },
};

export const separatorSx = {
  width: "100%",
  maxWidth: CONTENT_MAX_WIDTH,
  height: "1px",
  background: COLORS.borderLight,
  my: "40px",
};

export const skeletonAnimation = {
  "@keyframes settingsV2Skeleton": {
    "0%": {
      backgroundPosition: "200% 0",
    },
    "100%": {
      backgroundPosition: "-200% 0",
    },
  },
};

export const skeletonSx = {
  ...skeletonAnimation,
  background: "linear-gradient(90deg, #f5f7f9 25%, #eef2f6 50%, #f5f7f9 75%)",
  backgroundSize: "200% 100%",
  animation: "settingsV2Skeleton 1.2s ease-in-out infinite",
};

export const adminSectionTitleSx = {
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "18px",
  fontWeight: 500,
  lineHeight: "34px",
  m: 0,
};

export const adminSectionDescSx = {
  color: COLORS.textSecondary,
  fontFamily: FONT.family,
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "18px",
  m: 0,
};

export const adminSectionSeparatorSx = {
  width: "100%",
  maxWidth: CONTENT_MAX_WIDTH,
  height: "1px",
  bgcolor: COLORS.borderLight,
  my: "32px",
};

export const adminFeatureIconSx = {
  width: 64,
  height: 64,
  borderRadius: "8px",
  border: `1px solid ${COLORS.border}`,
  background: COLORS.white,
  boxShadow: COLORS.shadow,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const adminLogoPreviewSx = {
  width: 64,
  height: 64,
  borderRadius: "8px",
  border: `1px solid ${COLORS.primary}`,
  background: "#F3FBFF",
  boxShadow: "0 1px 2px 0 rgba(20, 141, 253, 0.10)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  color: COLORS.primary,
  fontFamily: FONT.family,
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: 1,
};

export const adminInputBorder = "#B7C2CC";

export const adminTextFieldSx = {
  width: "100%",
  maxWidth: CONTENT_MAX_WIDTH,
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: "8px",
    fontFamily: FONT.family,
    fontSize: "14px",
    fontWeight: 400,
    color: COLORS.textPrimary,
    boxShadow: COLORS.shadow,
    background: COLORS.white,
    "& fieldset": {
      borderColor: adminInputBorder,
    },
    "&:hover fieldset": {
      borderColor: adminInputBorder,
    },
    "&.Mui-focused fieldset": {
      borderColor: COLORS.primary,
    },
  },
  "& .MuiOutlinedInput-input": {
    py: 0,
    px: "12px",
    "&::placeholder": {
      color: COLORS.textPlaceholder,
      opacity: 1,
    },
  },
};

export const adminSelectSx = {
  ...adminTextFieldSx,
  "& .MuiSelect-select": {
    py: 0,
    px: "12px",
    display: "flex",
    alignItems: "center",
    minHeight: "40px !important",
    boxSizing: "border-box",
  },
};

export const adminDayLabelSx = {
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "34px",
  minWidth: 88,
  flexShrink: 0,
};

export const adminTimeFieldSx = {
  width: 104,
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: "8px",
    fontFamily: FONT.family,
    fontSize: "14px",
    boxShadow: COLORS.shadow,
    background: COLORS.white,
    "& fieldset": {
      borderColor: adminInputBorder,
    },
    "&:hover fieldset": {
      borderColor: adminInputBorder,
    },
    "&.Mui-focused fieldset": {
      borderColor: COLORS.primary,
    },
  },
  "& .MuiOutlinedInput-input": {
    py: 0,
    px: "8px",
    textAlign: "center",
    fontSize: "14px",
  },
};

export const adminToLabelSx = {
  color: COLORS.textSecondary,
  fontFamily: FONT.family,
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "18px",
  textAlign: "center",
  px: "8px",
  flexShrink: 0,
};
